
import { MainContent } from '@/components/layout/MainContent'
import { TopBar } from '@/components/layout/TopBar'
import { ThemeProvider } from '@/components/theme-provider'
import { ErrorBoundary } from '@/components/ui/custom/ErrorBoundary'
import { shortcuts, useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts'
import { useArtifactStore } from '@/store/artifactStore'
import { useUIStore } from '@/store/uiStore'
import { DEFAULT_HTML_TEMPLATE } from '@/utils/constants'
import { createRootRoute, Outlet, useRouter } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'

function RootComponent() {
  const router = useRouter()
  const createArtifact = useArtifactStore((state) => state.createArtifact)
  const { setViewMode, viewMode } = useUIStore()

  useKeyboardShortcuts({
    shortcuts: [
      shortcuts.new(() => {
        createArtifact({
          title: 'New Artifact',
          htmlContent: DEFAULT_HTML_TEMPLATE,
        }).then(artifact => {
          router.navigate({ to: '/editor/$id', params: { id: artifact.id } })
        })
      }),
      shortcuts.toggleView(() => {
        const newViewMode = viewMode.type === 'grid'
          ? { type: 'list' as const }
          : { type: 'grid' as const, itemsPerRow: 3 }
        setViewMode(newViewMode)
      }),
      shortcuts.escape(() => {
        router.navigate({ to: '/' })
      }),
    ],
  })

  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
      <ErrorBoundary>
        <div className="h-screen flex flex-col bg-background text-foreground">
          <TopBar />
          <MainContent>
            <Outlet />
          </MainContent>
          <TanStackRouterDevtools />
        </div>
      </ErrorBoundary>
    </ThemeProvider>
  )
}

export const Route = createRootRoute({
  component: RootComponent
}) 